import React from 'react'
import NumberFormat from 'react-number-format'
import TextField from '../TextField';

function DateField({
  label,
  name,
  id = name,
  dateFormat,
  placeholder = dateFormat.toLowerCase(),
  ...props
}) {
  return (
    <NumberFormat
      {...props}
      customInput={TextField}
      label={label}
      name={name}
      id={id}
      format={dateFormat.replace(/[a-zA-Z]/g, '#')}
      mask={dateFormat.toLowerCase().replace(/\//g, '').split('')}
      placeholder={placeholder}
    />
  )
}

DateField.defaultProps = {
  dateFormat: 'dd/MM/yyyy'
}

export default DateField
